import React from 'react';
import './StickyMobileCta.css';

export default function StickyMobileCta({ onClick }) {
  return (
    <div className="tp-sticky-cta">
      <button type="button" className="btn btn-primary tp-sticky-cta__btn" onClick={onClick}>
        Show me the bundles
      </button>
    </div>
  );
}
